import { GecBTMCore } from './core';
export type { GecBtmInitParams, IRegion, IManualReportType } from './types';
export { btmCopywritingPostProcessor, baseValidation } from '@i18nspect/tranquil';
const gecBTM = new GecBTMCore();
export default gecBTM;
